import './App.css';
import { Home, RecordedSessions,Events, Quizzes, Module,Support, Quiz, SessionVideo, Signup } from './pages';
import {Routes,Route} from "react-router-dom"
import { Suspense } from 'react';
import { CircularProgress } from '@mui/material';



function App() {
  return (
    <div className="App">

      <Suspense fallback={<CircularProgress/>}>

      <Routes>
    <Route path="/" element={<Home/>}/>
    <Route path="/recorded-sessions" element={<RecordedSessions/>}/>
    <Route path="/events" element={<Events/>}/>
    <Route path="/quizzes" element={<Quizzes/>}/>
    <Route path="/quizes/:id" element={<Quiz/>}/>
    <Route path="/module" element={<Module/>}/>
    <Route path="/support" element={<Support/>}/>
    <Route path="/:id" element={<SessionVideo/>}/>
    <Route path="/signup" element={<Signup/>}/>
      </Routes>

      </Suspense>
    </div>
  );
}

export default App;
